<template>
	<div class="right_body">
		<search-box :fromData="fromData" @subSearch="subSearch"></search-box>
    <list-btn :exportUrl="exportUrl" :exportWhere="fromData" isExcelExport></list-btn>
    <tab-list
    :tabList="listArr"
    :total="total"
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="report-purchasein-purchasein"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata">
    </tab-list>
	</div>
</template>

<script>
	import {report} from 'api/report.js';
  import {excelExport} from 'api/excel.js';
  import listBtn from 'components/btn/listBtn.vue';
  import tabList from 'components/table/list.vue';
	import searchBox from './components/index/search.vue'

	export default{
		components:{
			searchBox,
      tabList,
      listBtn
		},
		data() {
			return {
				sdata:{},
				listArr:[],//列表
        exportUrl:excelExport.purchaseinstock,//导出url
				tabColumns:[
				  {field: 'materailVoucherNo', title: '单据项目',need:true,width:100},
          {field:"type",title:"单据类型",width:80},
				  {field: 'voucherDate', title: '凭证日期', width:100},
				  {field: 'postingDate', title: '过账日期',width:100},
				  {field: 'materialCode', title: '物料编码',width:100},
				  {field: 'materialDesc', title: '物料描述'},
				  {field: 'quantity', title: '数量',width:80},
				  {field: 'basicUnitDesc', title: '计量单位'},
				  {field: 'supplierDesc', title: '供应商',
          formatter(row){
            let desc = row.susupplierDesc ? row.susupplierDesc : '';
            let code = row.supplierCode ? row.supplierCode : '';
            return code +'-'+desc;
          }},
				  {field: 'factoryCode', title: '工厂',
				  formatter(row, column, cellValue, index){
				    let desc = row.factoryDesc ? row.factoryDesc : '';
				    let code = row.factoryCode ? row.factoryCode : '';
				    return code +'-'+desc;
				  }},
				  {field: 'inventoryDesc', title: '库存地点',
				  formatter(row, column, cellValue, index){
				    let desc = row.inventoryDesc ? row.inventoryDesc : '';
				    let code = row.inventoryCode ? row.inventoryCode : '';
				    return code + '-'+desc;
				  }},
				  {field: 'standardCurrAmount', title: '采购金额'},
				  {field: 'currencyCode', title: '币种', width: 100},
				  {field: 'createUserName', title: '操作员'}
				],//表头字段

				total:0,//总条数
				pages:0,//总页数
				fromData:{
					page:1,//当前页
					pageSize:20,//每页显示的数量,
					searchCriteria:{//查询的附加条件

					},
				}
			}
		},
		created(){
			//设置默认日期最近一个月
      const startTime = new Date().getTime() - 3600 * 1000 * 24 * 30;
      const endTime = new Date();
      this.fromData.searchCriteria.startDate = this.$moment(startTime).format("YYYY-MM-DD");
      this.fromData.searchCriteria.endDate = this.$moment(endTime).format("YYYY-MM-DD");
			this.getList();
		},
		methods:{
      //选中数据
      selectSdata(data){
        this.sdata = data;
      },
			//获取列表
			async getList(){
				let res = await this.$post(report.purchasemng,this.fromData);
				if(res.status && res.data){
				  this.pages = res.data.pages;
				  this.listArr = res.data.list;
				  this.total = res.data.total;
				}else{
				  this.pages = 0;
				  this.listArr = [];
				  this.total = 0;
				}
			},
			//当前页码改变
			currentChange(currentPage){
				this.fromData.page = currentPage;
				this.getList();
			},
      //页码条数改变
      changePages(pages){
        this.fromData.page = 1;
        this.fromData.pageSize = pages;
        this.getList();
      },
			//搜索
			subSearch(){
				this.fromData.page = 1;
				this.getList();
			},
			handleSelectChange(item,key){
				if(item.isChecked){
					item.isChecked = false;
					this.sdata = {};
				}else{
					this.sdata = item;
					this.sdata.index = key;
					item.isChecked = true;
					this.listArr.forEach((items)=>{
						if(items.materialVoucherId != item.materialVoucherId){
							items.isChecked = false;
						}
					});
					if(item.maintainStatus === 'X'){
						this.sdata.isDel = true;
					}else{
						this.sdata.isDel = false;
					}
				}
			},
			//选择的改变
			changeSelect(val,item,key){
				this.handleSelectChange(item,key);
			},
			//详情
			goDetail(){
				if(!this.sdata.materialVoucherId){
					this.$message.error('请选择要查看的记得');
					return;
				}
				this.$router.push({name:'business-salebacks-detail',params:{id:this.sdata.materialVoucherId}});
			},
			//删除
			del(){
				let vm = this;
				if(!this.sdata.materialVoucherId){
					this.$message.error('请选择需要删除的');
					return;
				}
				this.$confirm('确定删除这条记录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(async () => {
					let res = await vm.$get(matterApi.del,{materialCode:this.sdata.materialCode});
					const {data,msg,status,code} = res;
					if(status){
						this.sdata.isDel = true;
						this.listArr[this.sdata.index] = this.sdata;
						vm.$message.success('操作成功');
					}else{
						vm.$message.error('操作失败');
					}
				})
				.catch(() => {
					/* this.$message({
						type: 'info',
						message: '已取消删除'
					});  */
				});
			},
			//恢复删除
			restore(){
				let vm = this;
				if(!this.sdata.materialVoucherId){
					this.$message.error('请选择需要恢复的物料');
					return;
				}
				this.$confirm('恢复此条记录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(async () => {
					let res = await vm.$get(matterApi.restore,{materialCode:this.sdata.materialCode});
					const {data,msg,status,code} = res;
					if(status){
						this.sdata.isDel = false;
						this.listArr[this.sdata.index] = this.sdata;
						vm.$message.success('操作成功');
					}else{
						vm.$message.error('操作失败');
					}
				});
			}

		}
	}
</script>

<style lang="stylus" scoped>

</style>
